import React from "react"
// import PropTypes from "prop-types"

DetailPage.propTypes = {}

function DetailPage(props) {
  return <div>Detail Page</div>
}

export default DetailPage
